import { joinURLPath } from '@sigma-frontend-libs/commons'

import { colorsHEX, getLocaleDateString, getLocaleTimeString, getUnixSeconds, globalErrorHandler, hexToRgb, request } from '@/utils'

import render from './render'

const colorsMap = {
  queue: colorsHEX.primary,
  speed: colorsHEX.success,
  count: colorsHEX.secondary,
  delivery_rate: colorsHEX.black
}

export default {
  name: 'Grafana',

  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },

    presets: {
      type: Array,
      default: () => {
        return []
      }
    },

    period: {
      type: Number,
      default: 5
    },

    hasFilter: Boolean,

    noData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      start: getUnixSeconds() - 5 * 60,
      end: getUnixSeconds(),

      step: 1,

      labels: [],
      datasets: [],

      range: 5,

      interval: undefined,

      loading: false,
      online: false
    }
  },

  computed: {
    chartOptions() {
      const scales = {
        x: { display: false },
        queue: {
          axis: 'y',
          min: 0,
          grace: '5%',
          display: false
        },
        speed: {
          axis: 'y',
          min: 0,
          grace: '5%',
          display: false
        },
        count: {
          axis: 'y',
          min: 0,
          grace: '5%',
          display: true
        },
        delivery_rate: {
          axis: 'y',
          min: 0,
          grace: '5%',
          display: false
        }
      }
      const result = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 8,
            right: 8
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        },
        scales,
        animation: { duration: 10 },
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
              font: {
                size: 12,
                lineHeight: '12px'
              }
            }
          },
          tooltip: {
            caretPadding: 8,
            bodySpacing: 4,
            padding: 8,
            cornerRadius: 12,
            usePointStyle: true
          }
        }
      }

      return result
    }
  },

  watch: {
    online() {
      if (this.online) {
        this.setInterval()
      } else {
        this.clearInterval()
      }
    }
  },

  mounted() {
    this.get()
  },

  beforeDestroy() {
    this.clearInterval()
  },

  methods: {
    async get() {
      try {
        if (!this.datasets.length) {
          this.loading = true
        }

        this.refreshTimeRange()

        await Promise.all(this.presets.map(async (item, index) => {
          const { label, name, preset } = item
          const data = await request.get(joinURLPath('grafana', 'range'), undefined, {
            data: this.data,
            preset,
            source: 'prometheus',
            start: this.start,
            end: this.end,
            params: { step: this.step * this.range }
          })
          if (Array.isArray(data) && data.length) {
            const labels = data.map(item => {
              const uTime = item[0] * 1000

              return getLocaleDateString(uTime) + ' ' + getLocaleTimeString(uTime)
            })
            this.labels.splice(0, this.labels.length || 0, ...labels)
            this.datasets.splice(index, 1, {
              label,
              yAxisID: name,
              data: data.map(item => {
                return item[1]
              }),
              fill: true,
              backgroundColor: `rgba(${hexToRgb(colorsMap[name], true)}, 0.1)`,
              borderWidth: 1,
              borderColor: colorsMap[name],
              pointBorderWidth: 0,
              pointHoverBorderWidth: 0,
              pointRadius: 2,
              pointHoverRadius: 4,
              pointHoverBackgroundColor: `rgba(${hexToRgb(colorsMap[name], true)}, 0.4)`
            })
          }
        }))
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    refreshTimeRange() {
      const now = getUnixSeconds()
      this.start = now - this.range * 60
      this.end = now
    },
    setInterval() {
      this.interval = setInterval(() => {
        if (this.online) {
          this.get()
        }
      }, this.period * 1000)
    },
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
      }
    }
  },

  render
}
